export default "__VITE_ASSET__Kp4R4WV2__"